import { render, staticRenderFns } from "./candidateDocuments.vue?vue&type=template&id=dca3276e&"
import script from "./candidateDocuments.vue?vue&type=script&lang=js&"
export * from "./candidateDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports